import React, { useState, useEffect } from 'react';

import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import { NEWSLETTER } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import eventEmitter from 'common/services/events/eventEmitter';

import NewsletterForm from './form-newsletter';
import NewsletterSubscribedMsg from './modal-newsletter-subscribed';

type Props = {
  campaignId: number;
  infoMsg?: string;
  subscribedMsg?: string;
  title?: string;
  trackingSubject?: string;
};

const NewsletterModal = ({
  campaignId,
  infoMsg = 'Subscribe to our newsletter',
  subscribedMsg = 'Modal subscribed with success',
  title = 'Subscribe',
  trackingSubject
}: Props) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(() => {
    eventEmitter.emit(TrackingEventNames.NEWSLETTER_PUSH, {
      eventAction: 'pop_up',
      eventLabel: 'impression',
      subject: trackingSubject
    });
  }, [trackingSubject]);

  return (
    <ReactModal size="large" className="modal-email" title={title}>
      {submitSuccess ? (
        <NewsletterSubscribedMsg displayCloseButton msg={subscribedMsg} />
      ) : (
        <NewsletterForm
          infoMsg={infoMsg}
          onSubmitSuccess={() => {
            setSubmitSuccess(true);
          }}
          campaignId={campaignId}
        />
      )}
    </ReactModal>
  );
};

let trackingSubject: string | undefined;

export default buildReactDomModalModule(
  NEWSLETTER,
  (params: Props) => {
    trackingSubject = params.trackingSubject;
    return (
      <NewsletterModal
        title={params.title}
        subscribedMsg={params.subscribedMsg}
        infoMsg={params.infoMsg}
        campaignId={params.campaignId}
        trackingSubject={params.trackingSubject}
      />
    );
  },
  () => {
    if (trackingSubject) {
      eventEmitter.emit(TrackingEventNames.NEWSLETTER_PUSH, {
        eventAction: 'pop_up',
        eventLabel: 'close',
        subject: trackingSubject
      });
    }
  }
);
